import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { timestampSelector } from '../../navigation/selectors/navigation.selectors';
import { qrsWaveListSelector } from '../../wave/selectors/wave.selectors';
import { getCursor } from '../../wave/utils/update.utils';

export const episodeMeasurementSelector = ({
  episodeMeasurement,
}: DefaultRootState) => episodeMeasurement;

export const episodeMeasurementUpdateModeSelector = createSelector(
  episodeMeasurementSelector,
  ({ updateMode }) => updateMode,
);

export const getEpisodeMeasurementCursor = createSelector(
  episodeMeasurementSelector,
  ({ updateMode }) => getCursor(updateMode),
);

export const previousEpisodeMeasurementTimestampSelector = createSelector(
  timestampSelector,
  episodeMeasurementSelector,
  (timestamp, state) =>
    state.updateMode === 'move' ? state.previousTimestamp : timestamp,
);

export const isMovingEpisodeMeasurementSelector = createSelector(
  episodeMeasurementUpdateModeSelector,
  (updateMode) => updateMode === 'move',
);

export const isUpdatingEpisodeMeasurementSelector = createSelector(
  episodeMeasurementSelector,
  ({ updateMode }) => updateMode != null,
);

export const episodeMeasurementRangeSelector = createSelector(
  episodeMeasurementSelector,
  ({ start, end }) => [Math.min(start, end), Math.max(start, end)],
);

export const episodeMeasurementMetricSelector = createSelector(
  episodeMeasurementRangeSelector,
  qrsWaveListSelector,
  ([start, end], qrsWaves) => {
    const episodeMeasurementContainedPoints = qrsWaves
      .filter((qrsWave) => qrsWave.onset >= start && qrsWave.onset <= end)
      .map((point) => point?.onset);
    if (episodeMeasurementContainedPoints.length === 0) {
      return;
    }
    const lastIndex = episodeMeasurementContainedPoints.length - 1;
    const episodeMeasurementDuration = Math.abs(
      episodeMeasurementContainedPoints[lastIndex] -
        episodeMeasurementContainedPoints[0],
    );
    if (episodeMeasurementDuration > 10_000) {
      return `${(episodeMeasurementDuration / 1000).toFixed(1)}s`;
    } else return `${episodeMeasurementDuration}ms`;
  },
);
